import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiService } from '@app/api/api.service';
import { MapTrackResponse } from '@app/models';

const prefix = '/map';

@Injectable({ providedIn: 'root' })
export class MapApi extends ApiService {
  public getOrderOnMap$(orderId: number): Observable<MapTrackResponse> {
    return this.get<MapTrackResponse>(`${prefix}/${orderId}/last`);
  }

  public getOrderOnMapByToken$(
    orderToken: string,
  ): Observable<MapTrackResponse> {
    return this.get<MapTrackResponse>(`${prefix}/byToken?token=${orderToken}`);
  }
}
